import EL, { HTMLELEMENT } from '../../EL/EL.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const imgAttr = makeAttrStruct([
    ['src'],
    ['alt'],
    ['width'],
    ['height'],
    ['loading'],
    ['crossorigin']
]);
export const imgData = makeDataStruct([
    ['srcset', ''],
    ['sizes', '']
]);
export const imgModel = makeStruct([
    ['attributes', imgAttr],
    ['data', imgData]
]);
export default class IMG extends EL {
    constructor(node, model) {
        super(node, HTMLELEMENT.IMG, model);
    }
}
